import * as runtypes from 'runtypes';

export const parse = (x: string): number | null => {
  try {
    return runtypes.Number.check(parseInt(x, 10));
  } catch (error) {
    return null;
  }
};
